import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {put, takeLatest} from "redux-saga/effects";
import {getUser} from './authCrud'

export const actionTypes = {
    Login: "[Login] Action",
    Logout: "[Logout] Action",
    LogoutRequest: "[Request Logout] Action",
    Register: "[Register] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API",
    SetUser: "[Set User] Action",
    RefreshToken: "[Refresh Token] Action",
    Permission: "[Permission] Action"
};

const initialAuthState = {
    token: undefined,
    refreshToken: undefined,
    user: {token: "", refreshToken: "", permissions: undefined},
    permissions: undefined
};

export const reducer = persistReducer(
    {
        storage,
        key: "Nard-admin",
        whitelist: ["token", "refreshToken", "user", "permissions"],
    },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                const {token, refreshToken} = action.payload;
                return {
                    ...state,
                    token: token,
                    refreshToken,
                };
            }

            case actionTypes.Register: {
                const {token} = action.payload;

                return {token: token, user: undefined};
            }

            case actionTypes.Logout: {
                return initialAuthState;
            }

            case actionTypes.UserLoaded: {
                const {user} = action.payload;
                return {...state, user};
            }

            case actionTypes.SetUser: {
                const {user} = action.payload;
                return {...state, user};
            }


            case actionTypes.RefreshToken: {
                const {token, refreshToken, expiredDate} = action.payload;

                return {
                    token: token,
                    refreshToken: refreshToken,
                    user: {
                        ...state.user,
                        token,
                        refreshToken,
                        expiredDate
                    }
                };
            }

            case actionTypes.Permission: {
                const {permissions} = action.payload;

                return {
                    ...state, permissions
                }
            }

            default:
                return state;
        }
    }
);

export const actions = {
    login: (token, refreshToken) => ({
        type: actionTypes.Login,
        payload: {token, refreshToken},
    }),

    register: (token) => ({
        type: actionTypes.Register,
        payload: {token},
    }),
    logout: () => ({
        type: actionTypes.Logout,
    }),

    requestUser: (user) => ({
        type: actionTypes.UserRequested,
        payload: {user},
    }),
    fulfillUser: (user) => ({
        type: actionTypes.UserLoaded,
        payload: {user},
    }),
    setUser: (user) => ({type: actionTypes.SetUser, payload: {user}}),
    setRefreshToken: (token, refreshToken, expiredDate) => ({
        type: actionTypes.RefreshToken,
        payload: {token, refreshToken, expiredDate},
    }),
    setPermission: (permissions) => ({
        type: actionTypes.Permission,
        payload: { permissions },
    }),
};

export function* saga() {
    yield takeLatest(actionTypes.UserRequested, function* () {
        try {
            const {data} = yield getUser();
            yield put(actions.setPermission(data.permissions));
            yield put(actions.fulfillUser(data));
        } catch (err) {

        }
    });
}
